import { defineAction } from '~/prix'
import userDeleteAction from './userDelete.action.json' with { type: 'json' }
import { z } from 'zod'

const userDeleteDefinition = defineAction({
  ...userDeleteAction,

  input: z.object({
    id: z.string(),
  }),
  output: z.object({
    data: z.object({
      id: z.string(),
    }),
    message: z.string(),
  }),
})

export default userDeleteDefinition
